export default {"src":"/_next/static/media/Z.ab8e87d4.svg","height":18,"width":18};